import { GroupAddresses } from "./group_addresses";

export class CallSourceBilling extends HTMLElement {
  constructor(auto_group) {
    super();
    this.auto_group = auto_group;
  }

  connectedCallback() {
    this.requestUpdate();
  }

  requestUpdate() {
    let dayOptions = [];
    for(let i = 1; i <= 31; i++) {
      dayOptions.push(`<option value="${i}">${i}</option>`)
    }
    this.innerHTML =
    `
    <style>
      callsource-billing select {
        margin-bottom: 10px;
      }
    </style>
      <div class="row">
        <div class="nav-tabs page-subtabs page-content-wrap nav" role="tablist" id='tablist3'>
          <a class="active" href="#contacts_tab" role="tab" data-toggle="tab">Contacts</a>
          <a href="#callsource_billing_tab" role="tab" data-toggle="tab">CallSource Billing</a>
        </div>
        <div class="panel-body tab-content">
          <div class="page-content-wrap page-subtabs-item tab-pane active" id="contacts_tab">

          </div>
          <div class="page-content-wrap page-subtabs-item tab-pane" id="callsource_billing_tab">
            ${this.auto_group.cs_billing_info ? `
              <div class="col-md-6 no-gutters">
                <h4>Account ID: ${this.auto_group.cs_billing_info.customer_id < 0 ? "AI" : ""}${this.auto_group.cs_billing_info.customer_id}</h4>
                <label>Billing Process</label>
                <select class="form-control" id="billing_process">
                  <option value="Recurring">Recurring</option>
                  <option value="Automation">Automation</option>
                </select>
                <label>Billing Method</label>
                <select class="form-control" id="back_billed">
                  <option value="Y">Back Billing</option>
                  <option value="N">Forward Billing</option>
                </select>
                <label>Billing Day</label>
                <select class="form-control" id="billing_day">
                  ${dayOptions.join('')}
                </select>
                <button id="callsource_billing_save" class="btn btn-primary pull-right">Save</button>
              </div>
              ` : `<a class="btn btn-primary" id="enable_group_callsource_billing">Enable CallSource Billing</a>`}
          </div>
        </div>
      </div>
    
    `

    if(this.auto_group.cs_billing_info) {
      this.querySelector("#billing_process").value = this.auto_group.cs_billing_info.billing_process;
      this.querySelector("#back_billed").value = this.auto_group.cs_billing_info.back_billed;
      this.querySelector("#billing_day").value = this.auto_group.billing_day;

      this.querySelector("#callsource_billing_save").addEventListener("click", this.save.bind(this))
    } else {
      this.querySelector("#enable_group_callsource_billing").addEventListener("click", this.enableCallSourceBilling.bind(this));
    }

    $(this).find(".page-subtabs a").on("click",function(e){
      $(this).find(".page-subtabs a").removeClass("active");
      $(e.target).addClass("active");
      $(this).find(".page-subtabs-item").removeClass("active");
      $($(e.target).attr("href")).addClass("active");
      return false;
    }.bind(this));

    let groupAddresses = new GroupAddresses(this.auto_group);
    this.querySelector('#contacts_tab').appendChild(groupAddresses);
  }

  async save() {
    try {
      let res = await fetch(`/admin/groups/${this.auto_group.id}/billing/cs_billing`, {
          headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                    'Content-type': 'application/json'},
          method: 'POST',
          body: JSON.stringify({
            billing_process: this.querySelector("#billing_process").value,
            back_billed: this.querySelector("#back_billed").value,
            billing_day: this.querySelector("#billing_day").value
          })
        })
      let data = await res.json();
      if(res.ok && data.success) {
        Common.notify("Successfully updates group.", 'success');  
      }
    } catch (exception) {
      Common.notify("Failed to update group.", 'error');
    }
  }

  async enableCallSourceBilling() {
    if(await confirmPlus("Are you sure you want to make this group billable to CallSource?")) {
      let res = await fetch(`/admin/groups/${this.auto_group.id}/enable_cs_billing`, {
          headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
          method: 'POST'}
        );
      let data = await res.json();
      if(res.ok && data.success) {
        this.auto_group = data.group;
        this.requestUpdate();
      }
    }
  }
}

customElements.define('callsource-billing', CallSourceBilling)